export default __webpack_public_path__ + "content/75c371c05f1cbb115959f5b1fe4bd134.svg";